import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'

const LabelElt = styled.label`
  display: block;
  width: 100%;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  color: var(--gray);
  font-weight: 500;
  font-size: 0.8rem;
`

export default class Label extends Component {
  render() {
    const { str, ...props } = this.props

    return (
      <LabelElt {...props}>
        <Text str={str} />
      </LabelElt>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Label.js